/**
 *
 * The EmailDesign duck. No reducer, currently fire and forget.
 *
 * Action Types:
 * - EMAIL_DESIGN_REQUESTED
 *
 * Action Creators:
 * - emailDesign()
 */

/** @type {ActionType} */
export const EMAIL_DESIGN_REQUESTED = 'PB/emailDesign/EMAIL_DESIGN_REQUESTED';

/**
 * Creates an EMAIL_DESIGN_REQUESTED action
 *
 * @return {Action}
 * @property {string} type MY_ACTION_TYPE
 */
export function emailDesign(cardId, email) {
  return {
    type: EMAIL_DESIGN_REQUESTED,
    payload: { cardId, email },
  };
}
